import { Table, TableHead, TableBody, TableRow, TableCell, Input, IconButton, Box, Button, DialogActions, DialogContent, DialogTitle, Grid, Link, SelectChangeEvent, TextField, Typography, FormControlLabel, Radio, RadioGroup, Chip } from '@mui/material';
import React, { FC, useEffect, useMemo, useState } from 'react';
import Divider from '@mui/material/Divider';
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';


import { useAppDispatch, useAppSelector, } from "../../store/hooks";
// import styles from './DialogAddressForm.module.css';
import CustomDataGrid from '../DataGrid/DataGrid';
import CustomTextField from '../FormFields/CustomTextField';
import CustomSelect, { IOptions } from '../FormFields/CustomSelect';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import LoadingButton from '@mui/lab/LoadingButton';
import CustomCheckbox from '../FormFields/CustomCheckbox';

import { ApiStatus } from "../../utils/api.types";
import { AInvoice } from '../../utils/invoice.types';
import { CashInflowPayment } from '../../utils/cashinflow.types';
import { fetchBanks } from '../../store/bankStore/bankThunk';
import { addCashInflowPayment } from '../../store/CashInflowStore/cashInflowThunk';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Utils } from "../../utils/common-utils";

import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';

interface DialogLegalFormProps {
  selectedBuyer: any;
  open: boolean;
  onClose: () => void;
  selectedInvoices?: any;
}

interface tableCellProps {
  row: any,
  name: string,
  onChange: any,
  align: string,
  type: string,
  readonly?: boolean,
};

const CustomTableCell = ({ row, name, onChange, align, type, readonly }: tableCellProps) => {
  const { isEditMode } = row;
  let val = row[name];
  if (name == 'Total') {
    let pricipalOrOutstanding = parseFloat(row['principalAmount']);
    let tax = calculateTax(pricipalOrOutstanding, row.tax1Percent);
    val = pricipalOrOutstanding - parseFloat(row['tds'] || 0);
  } else if (name == 'tax1') {
    let pricipalOrOutstanding = parseFloat(row['principalAmount']);
    let tax = calculateTax(pricipalOrOutstanding, row.tax1Percent);
    val = tax;
  }
  return (
    <TableCell width='175px' align={(align === 'center') ? 'center' : 'left'} className={'tableCell'} >
      {!readonly ?
        (<Input
          id={row._id + `${name}`}
          key={row._id + `${name}`}
          value={val}
          name={name}
          type={type}
          tabIndex={0}
          onChange={e => onChange(e, row)}
          className={'inputCell'}
          readOnly={(readonly) ? readonly : false}
        />) : (val)}
    </TableCell>
  );
};

const calculateTax = (amountEnteredByUser: any, taxPercent: any) => {

  let taxDecimal = (taxPercent / 100);
  let tax = amountEnteredByUser - (amountEnteredByUser / (1 + taxDecimal));
  // let tax = (amountEnteredByUser * taxDecimal);
  tax = Number(Number(tax).toFixed(2));
  return tax;
};

const calculateBase = (amountEnteredByUser: any, tax: any, tds: any) => {
  let base = Number(amountEnteredByUser) - Number(tax) - Number(tds);
  base = Number(Number(base).toFixed(2));
  return base;
};

const DialogRecievePaymentForm: FC<DialogLegalFormProps> = ({ open, selectedBuyer, onClose, selectedInvoices }) => {

  const dispatch = useAppDispatch();

  const { status } = useAppSelector(state => state.cashInflow);
  const { selectedAccount } = useAppSelector(state => state.auth);

  // getter & setter for form fields
  const [paymentDate, setPaymentDate] = useState<Date>(new Date(Date.now()));
  const [createDate, setCreateDate] = useState<Date>(new Date());

  // keep buyer details in state
  const [selectedBuyerName, setSelectedBuyerName] = useState<any>();
  const [selectedBuyerId, setSelectedBuyerId] = useState<any>();
  const [buyerDetails, setBuyerDetails] = useState<any>(selectedBuyer);
  const [selectedBuyerEmail, setSelectedBuyerEmail] = useState<any>();
  const [selectedBuyerWhatsapp, setSelectedBuyerWhatsapp] = useState<any>();


  const [selectedInvoicesUpdated, setSelectedInvoicesUpdated] = useState<AInvoice[]>([]);

  const [invoices, setInvoices] = useState<AInvoice[]>([]);
  const [clientInvoices, setClientInvoices] = useState<AInvoice[]>([]);


  // setter getter for payment receive
  const [amountRecevied, setAmountRecevied] = useState<Number>(0);

  // const [selectedBank, setSelectedBank] = useState("");
  // const [bankOptions, setBankOptions] = useState<IOptions[]>([]); 

  const { banks } = useAppSelector(state => state.banks);
  const [fromBank, setFromBank] = useState('');
  const [toBank, setToBank] = useState('');
  const [paymentMode, setPaymentMode] = useState('CASH');
  const [isCash, setIsCash] = useState(false);
  const [instrument, setInstrument] = useState('');
  const [ref1, setRef1] = useState('');
  const [ref2, setRef2] = useState('');
  const [ref3, setRef3] = useState('');
  const [copyOfSelectedInvoices, setCopyOfSelectedInvoices] = useState<AInvoice[]>([]);
  const [fromBankOptions, setFromBankOptions] = useState<IOptions[]>([]);
  const [toBankOptions, setToBankOptions] = useState<IOptions[]>([]);
  const [fetchInvoices, setFetchInvoices] = useState<AInvoice[]>([]);

  // Schema to validate payment form.
  const schema = yup.object().shape({
    paymentFrom: yup.string().required("Payment from is required."),
    paymentDate: yup.string().required("Payment date is required."),
    paymentMode: yup.string().required("Payment mode is required."),
    // toBankAccount: yup.string().required("To bank account is required."),
    // fromBankAccount: yup.string().required("From bank account is required."),
    currency: yup.string().required("Currency is required."),
    amount: yup.string().required("Amount is required."),
  });

  const methods = useForm<any>({ mode: 'onChange', reValidateMode:'onChange', resolver: yupResolver(schema) });
  const {control, register} = methods;

  // Select first bank name on form load.
  // useEffect(() => {
  //   if (bankOptions.length > 0) {
  //     if (!selectedBank) {
  //       setSelectedBank(bankOptions[0].value)
  //     } else if (payToObj === undefined) {
  //       setSelectedBank(bankOptions[0].value)
  //       let currentBank = banks.find((item: any) => item._id === bankOptions[0].value);
  //       let paytoObj = {
  //         "bankAccount": bankOptions[0].value,
  //         "copyBankAccountDetails": {
  //           "accountName": currentBank?.accountName,
  //           "accountNumber": currentBank?.accountNumber,
  //           "IFSC": currentBank?.IFSC,
  //           "bankName": currentBank?.bankName,
  //           "qrCodeLink": account.qrCodeUrl
  //         }
  //       };
  //       onChangePayTo(paytoObj)
  //     }
  //   }
  // }, [bankOptions, banks, selectedBank, payToObj, account]);

  useEffect(() => {
    console.log(selectedBuyer.email)
    setSelectedBuyerWhatsapp(selectedBuyer.whatsAppNumber);
    setSelectedBuyerEmail(selectedBuyer.email);
    setSelectedBuyerName(selectedBuyer.name);
    setSelectedBuyerId(selectedBuyer._id);
    methods.setValue('paymentDate', paymentDate);
  }, []);

  // Function to collect data
  const getApiData = async () => {
    let queryString = "&filter=" + buyerDetails._id;
    queryString += "&voucherType=Invoice&status=PENDING,PARTIALLY_PAID";
    let path = `${selectedAccount._id}/account-receivables`;
    console.log(queryString);
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}api/v1/invoice/account/${path}?limit=500${queryString}`
    ).then((response) => response.json());

    // Calculate Sum of outstanding for the fetched invocies
    let totalOutstanding =  Number(0);
    response.invoices.map((a: any) => {
      totalOutstanding += Math.round(Number(a.openingBalance));
      return a;
    });
    console.log("Calculated total outstanding after initial outstanding to be received  ===>" + totalOutstanding);
    setAmountRecevied(totalOutstanding);

    let data12 = response.invoices.map((row: any) => {
      // Ensure paymentAmount is rounded to whole number
      return { ...row, paymentAmount: Math.round(Number(row.openingBalance)) };
    });
    setFetchInvoices(data12);
  };

  useEffect(() => {
    // if(fetchInvoices.length == 0) {
    //   getApiData();
    // }
    getApiData();
  }, []);


  useEffect(() => {
    console.log("22222 Use effect called -----> ");
    let totalOutstanding =  Number(0);
    console.log("total outstanding first .... " + amountRecevied);
    setInvoices(clientInvoices.map((a: any) => {
      let invoiceOutstanding = Number(a.openingBalance);
      totalOutstanding += invoiceOutstanding;
      console.log("total outstanding after updation .... " + totalOutstanding);
    
      return a;
    }));

    console.log("total outstanding .... " + totalOutstanding.toString())

    setAmountRecevied(totalOutstanding);

    const getBanks = async () => {
      const banks: any = await dispatch(fetchBanks(selectedAccount._id));
      setFromBankOptions(banks.payload.banks.map((c: any) => {
        return { label: c.accountName + '-' + c.bankName, value: c._id }
      }));

      if (fromBankOptions.length == 1 ) {
        setFromBank(banks.payload.banks[0]._id);
      }

      // const toBanks: any = await dispatch(fetchBanks(invoices[0].supplier._id));
      // setToBankOptions(toBanks.payload.banks.map((c: any) => {
      //   return { label: c.accountName + '-' + c.bankName, value: c._id }
      // }));

      setFromBank(banks.payload.banks[0]._id);
      setToBank(banks.payload.banks[0]._id);
      return banks;
    };
    getBanks();
  }, [dispatch]);

  const handleClose = () => {
    setFetchInvoices([]);
    onClose();
  };


  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      if (name === 'paymentDate')
        setPaymentDate(newValue);
      else
        setCreateDate(newValue);
    }
  };

  const onSubmit = async (data: any) => {
    console.log(data);
    console.log("onsubmit clicked");
    console.log(methods);

    if (selectedInvoicesUpdated.length <= 0) {
      toast.error("Please select atleast one invoice to receive the payment");
      return
    }
    if (toBank == '') {
      toast.error("Please select deposit to bank");
      return
    }
    let addPaymentReqObj: CashInflowPayment = {
      "account": selectedAccount._id,
      "paymentDate": Number(paymentDate),
      "bankDepositDate": Date.now(),
      "bankClearingDate": Date.now(),
      "entryDate": Date.now(),
      "amount": amountRecevied,
      "currency": "62a4b0ceb628fb10ac97ce0e",
      "toBankAccount": toBank,
      "paymentMode": paymentMode.toUpperCase(),
      "instrument": paymentMode,
      "instrumentDate": new Date(paymentDate).getTime(),
      "fromBankAccount": "",
      "ref1": "",
      "ref2": "",
      "ref3": "",
      "paymentStatus": "RECEIVED",
      "appliedFlag": false,
      "invoices": selectedInvoicesUpdated
    };



    // let total = Number(submitData.base) + Number(submitData.tax) + Number(submitData.tds);
    // let attachPaymentToInvoice: PaymentReceipt = {
    //   invoice: selectedInvoice[0],
    //   activityType: 'CHECK',
    //   appliedAmountBase: amountRecevied,
    //   appliedAmountTax: Number(0),
    //   appliedAmountTDS: Number(0),
    //   appliedDate: new Date().getTime().toString(),
    //   appliedAmountTotal: amountRecevied,
    //   remarks: "PAID"
    // };
    // let payLoad: PaymentReceiptApplication = {
    //   payments: [attachPaymentToInvoice]
    // };

    // if (isInflow) {
    //   attachPaymentToInvoice["paymentReceipt"] = data.payment_id;
    //   await dispatch(attachInvoiceToPayment(payLoad));
    // } else {
    //   attachPaymentToInvoice["vpId"] = data.payment_id;
    //   await dispatch(manualPayment(payLoad));
    // }

    console.log(addPaymentReqObj);
    
    addPaymentReqObj["paymentFrom"] = selectedBuyerId;
    await dispatch(addCashInflowPayment(addPaymentReqObj)).unwrap();
    methods.reset();
    handleClose();
  };

  const onChange = (e: any, row: any) => {

    // update total amount for invoices, row cell data ( pyament )
    console.log( "START ---> On Change event track 11")

    console.log(e.currentTarget.name);
    console.log(e.currentTarget.value);

    setFetchInvoices(current =>
      current.map(obj => {
        if (obj._id == row._id) {
          let currentPaymentValue = row.balanceAmount;
          if (e.target.name == 'paymentAmount') {
            console.log("validate target name" + e.target.name);
            currentPaymentValue = e.target.value || 0
            // setAmountRecevied(amountRecevied + currentPaymentValue);
          } 
          let returnObj = {
            ...obj, ["paymentAmount"] : Number(currentPaymentValue) || 0
          };
          // console.log("returnObj "+JSON.stringify(returnObj));
          // console.log(amountRecevied);
          // console.log(e.target.value);
          // console.log(typeof(amountRecevied) );
          // console.log(typeof(e.target.value) );
          // console.log(typeof(Number(e.target.value)));
          // let ttt = currentPaymentValue + Number(e.target.value) ;
          // console.log(ttt);
          // setAmountRecevied(ttt);
          // console.log(amountRecevied)
          return returnObj;
        }
        return obj;
      }),
    );

  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let val = (event.target as HTMLInputElement).value;
    if (val == 'Cash') {
      setIsCash(true);
    } else {
      setIsCash(false);
    }
    setPaymentMode((event.target as HTMLInputElement).value);
  };

  const onRowsSelectionHandler = (ids: any) => {
    console.log("ids mapping for updateing selected invoices....");
    console.log(ids);

    let totalOutstanding =  Number(0);

    if (ids.length > 0) {
      const selectedRowsData = ids.map((id: any) => {
        let row = fetchInvoices.find((row) => row._id == id);
        console.log(row?._id);
        // Ensure consistent rounding to whole number
        let invoiceOutstanding = row?.paymentAmount ? Math.round(Number(row?.paymentAmount)) : Math.round(Number(row?.openingBalance));
        console.log(invoiceOutstanding);
        totalOutstanding += invoiceOutstanding;
        console.log("total outstanding after updation .... " + totalOutstanding);

        return row

      });
      // Use total as whole number (already rounded from individual amounts)
      setAmountRecevied(Number(totalOutstanding));
      setSelectedInvoicesUpdated(selectedRowsData);
    } else {
      setAmountRecevied(Number(0));
      setSelectedInvoicesUpdated([]);
    }

  };

  const columns: GridColDef[] = useMemo(() => {
    let gridCols = [];
    gridCols = [
      {
        field: "invoiceNumber",
        headerName: 'Invoice #',
        type: "string",
        flex: 1,
        renderCell: ({ row, value }: GridValueGetterParams) => (
          <Typography >
              {row.invoiceNumber}
          </Typography>
        )
      },
      {
        field: "dueDate",
        headerName: 'Due Date',
        type: "string",
        flex: 1,
        renderCell: ({ row, value }: GridValueGetterParams) => (
          <Typography style={{ marginLeft: '-8px' }}>
              { moment(row.payBydate).format("DD MMM YYYY")}
          </Typography>
        )
      },
      {
        field: "amount",
        headerName: 'amount',
        type: "string",
        flex: 1,
        renderCell: ({ row, value }: GridValueGetterParams) => (
          <Typography>
              {/* { Utils.formatNumber(parseFloat(row.amount + Utils.additionalChargesSum(row)).toFixed(2) || '0') } */}
              { Utils.formatNumber(parseFloat(row.finalAmount || (row.amount + Utils.additionalChargesSum(row)).toFixed(2)) || '0') }
          </Typography>
        )
      },
      {
        field: "status",
        headerName: 'status',
        type: "string",
        flex: 1,
        renderCell: ({ row, value }: GridValueGetterParams) => (
          <Typography>
             { row.status }
          </Typography>
        )
      },
      {
        field: "openingBalance",
        headerName: 'Balance',
        type: "string",
        flex: 1,
        renderCell: ({ row, value }: GridValueGetterParams) => (
          <Typography>
             { row.balanceAmount ? Utils.formatNumber(Math.round(row.balanceAmount) || 0, true, true) : 0}
          </Typography>
        )
      },
      {
        field: "paymentReceived",
        headerName: 'Payment In',
        type: "int",
        flex: 1,
        renderCell: ({ row, value }: GridValueGetterParams) => (
          // <CustomTextField

          //   style={{ margin: '5px 0px' }}
          //   variant="standard"
          //   label=""
          //   name="payment" 
          //   value={row.paymentAmount}/>
          <TextField
            type='text'
            // value={ Utils.formatNumber(row.paymentAmount || 0, true, true)}
            style={{marginRight: 10}}
            value={row.paymentAmount}
            name="paymentAmount"
            variant='outlined'
            size='small'
            onChange={e => onChange(e, row)}
            // className={'c-text-field'}
          />
        )
      }
    ];

    return gridCols;
  },
    []);

  return (
    <div style={{width: '65vw', maxWidth: '65vw'}}>

      <Box
        sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: "16px 0 16px 16px" }}
        component="form"
        noValidate>
        <FormProvider {...methods}>
          <DialogTitle>
            <Box sx={{ display: "flex", mt: 2, justifyContent: "space-between" }}>
              <Typography variant="h4">Recieve Payment </Typography>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Grid container justifyContent="center" spacing={2} rowSpacing={-2} style={{ height: '90vh', width: '100%' }}>
              <Grid container>
                <Grid item xs={12}>
                  <Box sx={{ borderRadius: '12px', border: '3px solid #e9ecf1', backgroundColor: '#fff' }}>
                    <Grid container>
                      
                      <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, pt: 1.5, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, maxHeight: 120, width: 100 }} >
                      
                        <h3 style={{ marginTop: -1, fontWeight: 600 }}> 
                          <IconButton
                            style={{ color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 15, marginLeft: -5 }}
                            size='small'>
                            <PeopleAltTwoToneIcon style={{ fontSize: 20 }} />
                          </IconButton>
                          {selectedBuyerName} 
                        </h3>
                        <Typography style={{marginLeft: 45}}>
                          <Chip 
                            size='small' 
                            style={{height:28,borderRadius:7,color:'#767676',backgroundColor:'#fff',fontSize:13, marginRight: 10, marginBottom: 10}}
                            label={`Phone:  ${selectedBuyerWhatsapp || 'N/A'}`}
                          />
                        </Typography>
                        <Typography style={{marginLeft: 45}}>
                        { selectedBuyerEmail && selectedBuyerEmail.slice(0,2).map((e:any) =>
                            <Chip 
                                size='small' 
                                style={{height:28,borderRadius:7,color:'#767676',backgroundColor:'#fff',fontSize:13, marginRight: 10, marginBottom: 10}}
                                label={e}
                            />
                        )}
                        </Typography>
                        
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
              {/* <StyledSectionTable> */}
              <LocalizationProvider dateAdapter={AdapterDateFns}>

              <Grid item xs={12} display="flex" justifyContent="flex-end" style={{marginTop: 30}}>
                <Grid container spacing={2} rowSpacing={-2}>
                  <Grid item xs={4} md={4} sm={4} lg={4}>
                    <DesktopDatePicker
                        label="Payment Date"
                        inputFormat="dd/MM/yyyy"
                        maxDate={moment().add(1).toDate()}
                        value={paymentDate}
                        onChange={(value) => { handleDateChange(value, 'paymentDate') }}
                        renderInput={(params) => <TextField {...params} name={'paymentDate'} required variant="outlined" size='small' style={{width: 270}} />}
                      />
                  </Grid>

                  <Grid item xs={4} md={4} sm={4} lg={4}>
                    {fromBankOptions.length > 0 && <CustomSelect
                        disabled={isCash}
                        // style={{ margin: '30px 30px' }}
                      name="depositTo"
                      label="Deposit To"
                      id="depositTo"
                      variant="outlined"
                      size='small'
                      options={fromBankOptions}
                      value={fromBank ?? ""}
                      onChange={(event: SelectChangeEvent<any>) => {
                        methods.setValue('toBankAccount', event.target.value);
                        setFromBank(event.target.value);
                        setToBank(event.target.value);
                      }} />
                    }
                  </Grid>
                  <Grid item xs={4} md={4} sm={4} lg={4}>
                    <div style={{textAlign: 'center'}}>
                      <Typography variant="h5" style={{color: '#647f64'}}> Total Amount To Be Received  </Typography>
                      <Typography variant="h3" style={{color: 'green'}}>  {Utils.formatNumber(amountRecevied || 0, true, true)}</Typography>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12} sm={12} lg={12}>
                    <RadioGroup
                      {...methods.register("instrumentType")}
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="CASH"
                      name="instrumentType"
                      style={{ margin: '0px 0px' }}
                      onChange={(handleRadioChange)}>
                      <FormControlLabel style={{marginRight: 25}} value="CASH" control={<Radio />} label="Cash" />
                      <FormControlLabel style={{marginRight: 25}} value="CHEQUE" control={<Radio />} label="Cheque" />
                      <FormControlLabel style={{marginRight: 25}} value="CARD" control={<Radio />} label="Card" />
                      <FormControlLabel style={{marginRight: 25}} value="UPI" control={<Radio />} label="UPI" />
                      <FormControlLabel style={{marginRight: 25}} value="NETBANKING" control={<Radio />} label="Netbanking" />
                    </RadioGroup>
                  </Grid>
                  <Grid item xs={12} md={4} sm={4} lg={4}>
                    <CustomTextField
                      style={{ margin: '5px 0px' }}
                      disabled={isCash}
                      variant="outlined"
                      size='small'
                      label="Cheque Number or UPI Id or Trxn ID"
                      name="instrumentId" />
                  </Grid>
                  <Grid item xs={12} md={4} sm={4} lg={4}>
                    <CustomTextField style={{ margin: '5px 0px' }}
                      variant="outlined"
                      size='small'
                      label="Ref Note 1 "
                      name="ref1" />
                  </Grid>
                  <Grid item xs={12} md={4} sm={4} lg={4}>
                    <CustomTextField style={{ margin: '5px 0px' }}
                      variant="outlined"
                      size='small'
                      label="Ref Note 2"
                      name="ref2" />
                  </Grid>
                </Grid>
              </Grid>
              </LocalizationProvider>

              <Divider style={{width: '100%', margin: '20px 5px 15px'}}/>
              <Grid item xs={12} display="flex" justifyContent="flex-end" >
                <Grid container justifyContent="left">
                    <Grid item xs={12}>
                    <Typography variant="h5"> Check the boxes to mark payments for multiple invoices. </Typography>
                    <Typography> {selectedInvoicesUpdated.length > 0 && `Selected Invoices:` } {selectedInvoicesUpdated.map(invoice => `${invoice.invoiceNumber} , `)} </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <div style={{ height: 400, width: '100%', paddingTop: '10px' }}>
                <CustomDataGrid
                  isRowSelectable={(params: any) =>
                      params.row.status != 'DRAFT' && params.row.status != 'PAID' && params.row.status != 'OVER_PAID'}
                  onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
                  checkboxSelection={true}
                  // disableSelectionOnClick
                  columns={columns}
                  // rows={fetchInvoices.filter((invoice:any) => invoice._id == selectedInvoices[0]._id)}
                   rows={fetchInvoices}
                  getRowId={(row) => row._id}
                  loading={status === ApiStatus.LOADING} />
              </div>

              
            </Grid>
          </DialogContent>

          <DialogActions>
            <Grid container gap='0' sx={{ mr: '32px', pt: '10px' }}>
              <Grid item xs={12} md={12} sm={12} lg={12} display="flex" justifyContent="flex-end" >

              <Button variant='contained'
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    methods.reset();
                    handleClose();
                  }}>Cancel</Button>
                <LoadingButton
                  type="button"
                  onClick={onSubmit}
                  variant="contained"
                  loading={status === ApiStatus.LOADING}>
                  Record Payment
                </LoadingButton>
              </Grid>
            </Grid>
          </DialogActions>
        </FormProvider>
      </Box>
    </div>
  );
};

export default DialogRecievePaymentForm;
